"use client"

import { useEffect, useRef } from "react"

import { logger } from "@/platform/observability/logger"

export interface FeedAnomalyEntry {
  event: string
  sectionId: string
  sectionType: string
}

// Authoring anomalies are computed during the (server) render and logged once per
// section here, after hydration. The ref survives scroll batches re-delivering the
// same section with a fresh array identity, so each anomaly is reported once.
export const FeedAnomalyLog = ({ entries, pageHandle }: { entries: FeedAnomalyEntry[]; pageHandle: string }) => {
  const logged = useRef(new Set<string>())
  useEffect(() => {
    for (const entry of entries) {
      if (logged.current.has(entry.sectionId)) continue
      logged.current.add(entry.sectionId)
      logger.info(entry.event, { sectionId: entry.sectionId, sectionType: entry.sectionType, pageHandle })
    }
  }, [entries, pageHandle])
  return null
}
